import React, { useEffect, useState } from 'react';
import { ref, get } from 'firebase/database';
import { database } from '../firebaseConfig';
import { useAuth } from '../context/AuthContext';

// Admin page section: the ONE team-level BoldTrail token. Sent once to the server (admin-checked there),
// encrypted, stored at boldtrail/teamToken, and never shown again. Only last 4 + saved date are displayed.
export default function BoldTrailTeamConnection() {
  const { user, userRole } = useAuth();
  const [token, setToken] = useState('');
  const [state, setState] = useState(null);
  useEffect(() => {
    if (userRole !== 'Admin') return;
    get(ref(database, 'boldtrail/teamToken')).then((s) => {
      const v = s.val();
      if (v && v.last4) setState({ saved: true, last4: v.last4, savedAt: v.savedAt });
    }).catch(() => null);
  }, [userRole]);
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);
  const call = async (method, body) => {
    setBusy(true); setMsg('');
    try {
      const idToken = await user.getIdToken();
      const r = await fetch('/api/boldtrail-token', { method, headers: { Authorization: `Bearer ${idToken}`, 'Content-Type': 'application/json' }, body: body ? JSON.stringify(body) : undefined });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || 'Could not save.');
      setState(d.saved ? d : null); setToken('');
      setMsg(d.saved ? 'Saved. For your security it will not be shown again.' : 'Token removed.');
    } catch (e) { setMsg(e.message); } finally { setBusy(false); }
  };
  if (userRole !== 'Admin') return null;
  return (
    <div style={{ background: '#fff', color: '#1A1A1A', borderRadius: 12, padding: 20, margin: '16px 0', boxSizing: 'border-box' }}>
      <h2 style={{ marginTop: 0, fontSize: 18 }}>BoldTrail team connection</h2>
      <p style={{ lineHeight: 1.5 }}>Save the team BoldTrail token here. Resi uses this one token to bring in the whole team's new leads and matches each lead to an agent by their BoldTrail agent number (set on each user's Edit User form). Agents never see this and do not need their own token.</p>
      {state && <p style={{ fontWeight: 600 }}>A token is saved (ending in {state.last4}).</p>}
      <input type="password" autoComplete="off" value={token} onChange={(e) => setToken(e.target.value)}
        placeholder={state ? 'Paste a new token to replace it' : 'Paste the team token'}
        style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box', padding: 10, borderRadius: 8, border: '1px solid #ccc', fontSize: 14 }} />
      <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
        <button type="button" disabled={busy || !token.trim()} onClick={() => call('POST', { token })}
          style={{ padding: '10px 16px', borderRadius: 8, fontWeight: 700, border: '1px solid #B8962E', background: '#B8962E', color: '#fff', cursor: 'pointer' }}>Save token</button>
        {state && <button type="button" disabled={busy} onClick={() => call('DELETE')}
          style={{ padding: '10px 16px', borderRadius: 8, border: '1px solid #999', background: '#fff', cursor: 'pointer' }}>Remove</button>}
      </div>
      {msg && <p style={{ marginBottom: 0 }}>{msg}</p>}
    </div>
  );
}
